const About = () =>{
    return(
        <div>
            <h1>About Page</h1>
            <p>This is about me</p>
        </div>
    )
}

export default About